import React, { useState, useEffect, useContext } from "react";
import { ReactReduxContext, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  removeFromCart,
  updateCart,
  cartFetch,
  clearCartData
} from "../../features/cartSlice";
import Carttitle from "../cart/Carttitle";

import Cartitems from "../cart/Cartitems";
import Carttotal from "../cart/Carttotal";

import { useAuth } from "../../hooks/customers/AuthProvider";
import { LoaderContext } from "../utils/Contexts";

function Cart() {
  /*const { store } = useContext(ReactReduxContext);
  console.log('store', store.getState());*/
  const cart = useSelector((state) => state.cart.cartData);
  const cartLoad = useSelector((state) => state.cart.loading);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translations = {
    added_to_cart: t("added_to_cart"),
    items_added_to_cart: t("items_added_to_cart"),
    removed_from_cart: t("removed_from_cart"),
    qty_updated_cart: t("qty_updated_cart"),
    cart_cleared: t("cart_cleared")
  };
  const auth = useAuth();
  const customer = auth.customer;
  const customerId = customer._id;
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [cartData, setCartData] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  console.log('cartItems',cartItems);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [reloadCart, setReloadCart] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [clearCartPopup, setClearCartPopup] = useState(false);

  const deleteItem = async (e) => {
    setLoader(true);
    dispatch(
      removeFromCart({
        cart_id: cartData._id,
        item_id: e.currentTarget.getAttribute("data-item-id"),
        name: e.currentTarget.getAttribute("data-item-name"),
        product_id: e.currentTarget.getAttribute("data-product-id"),
        translations,
      })
    );
    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
    }, 2000);
  };

  const updateItem = async (qty, itemId, name, product_id) => {
    setLoader(true);
    if (qty <= 0) {
      dispatch(
        removeFromCart({
          cart_id: cartData._id,
          item_id: itemId,
          name: name,
          product_id: product_id,
          translations,
        })
      );
    } else {
      dispatch(
        updateCart({
          cart_id: cartData._id,
          item_id: itemId,
          qty: qty,
          name: name,
          product_id: product_id,
          translations,
        })
      );

    }

    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
      setReloadCart(true);
    }, 1500);
  };

  useEffect(() => {
    if (reloadCart && !cartLoad) {
      dispatch(cartFetch());
      setReloadCart(false);
    }
  }, [reloadCart, cartLoad]);

  useEffect(() => {
    if (cart?.cart) {
      setCartData(cart?.cart);
      setCartItems(cart?.items);
      const initialQuantities = {};
      cart?.items.forEach((item) => {
        initialQuantities[item._id] = item.quantity;
      });
      setQuantities(initialQuantities);
    } else if (cart === null || cart?.length <= 0 || cart?.cart?.length <= 0) {
      setCartData([]);
      setCartItems([]);
    } else {
      dispatch(cartFetch());
    }
    //getCartData();
  }, [cart]);

  useEffect(() => {
    setIsDataLoaded(!cartLoad);
  }, [cartLoad]);

  const handleClearCart = async (e) => {
    setLoader(true);
    dispatch(
      clearCartData({
        cart_id: cartData._id,
        translations
      })
    );
    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
    }, 1000);
    setClearCartPopup(false);
  };

  const handleCancel = () => {
    setClearCartPopup(false);
  };

  const handleCart = () => {
    setClearCartPopup(true);
  };

  return (
    <div className="favbg">
      <div className="innerwrapper Favourites_search">
        <div className="search_fav">
          <Carttitle  onClearCart={handleClearCart} showClearButton={cartItems && cartItems.length > 0}
           handleCancel={handleCancel} handleCart={handleCart} clearCartPopup={clearCartPopup}/>
          {cartItems && cartItems.length > 0 && (
            <div className="cartmain">
              <Cartitems
                deleteItem={deleteItem}
                updateItem={updateItem}
                cartLoad={cartLoad}
                cartData={cartData}
                cartItems={cartItems}
                quantities={quantities}
              />
              <Carttotal
                cartData={cartData}
                cartItems={cartItems}
                customer={customer}
              />
            </div>
          )}

          {isDataLoaded &&
            ((cartItems && cartItems.length <= 0) || !cartItems) && (
              <div
                className={`cart-empty ${cartItems?.length === 0 ? "active" : ""
                  }`}
              >
                {t("shopingcart_emptymsg")}
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default Cart;
